var m = Object.defineProperty, A = Object.defineProperties;
var E = Object.getOwnPropertyDescriptors;
var l = Object.getOwnPropertySymbols;
var h = Object.prototype.hasOwnProperty, I = Object.prototype.propertyIsEnumerable;
var d = (e, t, n) => t in e ? m(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, f = (e, t) => {
  for (var n in t || (t = {}))
    h.call(t, n) && d(e, n, t[n]);
  if (l)
    for (var n of l(t))
      I.call(t, n) && d(e, n, t[n]);
  return e;
}, w = (e, t) => A(e, E(t));
import { createContext as C, createElement as s, useContext as T, useRef as c, useEffect as p } from "react";
const a = C(null);
function x({ client: e, children: t }) {
  return s(a.Provider, { value: e }, t);
}
function L() {
  const e = T(a);
  if (!e)
    throw new Error("[analytics] useAnalytics must be used within an <AnalyticsProvider>.");
  return e;
}
const P = 3e4, R = 1e3, v = ["mousemove", "mousedown", "keydown", "scroll", "touchstart"];
function S(e) {
  const t = c(0), n = c(0), r = c(!1);
  p(() => {
    n.current = Date.now();
    const u = () => {
      n.current = Date.now();
    };
    v.forEach((i) => window.addEventListener(i, u, { passive: !0 }));
    const y = setInterval(() => {
      Date.now() - n.current < P && (t.current += 1);
    }, R), o = () => {
      r.current || (r.current = !0, e.track("page.time-on-page", {
        duration_seconds: t.current
      }));
    };
    return window.addEventListener("beforeunload", o), () => {
      clearInterval(y), v.forEach((i) => window.removeEventListener(i, u)), window.removeEventListener("beforeunload", o), o();
    };
  }, [e]);
}
function g(e) {
  return function(n) {
    return s(a.Consumer, {
      children: (r) => {
        if (!r)
          throw new Error("[analytics] withAnalytics must be used within an <AnalyticsProvider>.");
        return s(e, w(f({}, n), { analytics: r }));
      }
    });
  };
}
export {
  x as AnalyticsProvider,
  L as useAnalytics,
  S as useTimeOnPage,
  g as withAnalytics
};



//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/mx-teacher-analytics/dist/react.js
// module id = /urO
// module chunks = 0